import { createSlice } from "@reduxjs/toolkit";
import { api } from './apiSlice'

export const partnersApiSlice = api.injectEndpoints({
    endpoints: build => ({
        archiveListing: build.mutation({
            query: partnerListingId => ({
                url: `/listings/${partnerListingId}/archive`,
                method: 'POST'
            }),
        }),
        fetchPartnerBySearchTerm: build.query({
            query: ({ searchTerm, bypassPublishedListingReq }) => ({
                url: `/partners?SearchTerm=${searchTerm}&BypassPublishedListingReq=${bypassPublishedListingReq}`
            }),
            transformResponse: (response) => {
                const partners = response && response.data ?
                    response.data.map(partner => ({ id: partner.id, name: partner.name })) : []
                return { partners }
            }
        }),
        fetchPartnerNetSuiteMarketplaceCustomer: build.query({
            query: (partnerId) => ({
                url: `netsuite/customer/partner/${partnerId}`,
                method: 'GET',
            }),
        }),
        deletePartnerCustomer: build.mutation({
            query: (partnerId) => ({
                url: `netsuite/customer/${partnerId}`,
                method: 'DELETE',
            }),
        }),

        getNetSuiteImport: build.query({
            query: ({ id }) => {
                return ({
                    url: `netsuite/imports/${id}`,
                    method: 'GET',
                })
            },
            providesTags: ['NetSuiteImports'],
        }),
        getNetSuiteImports: build.query({
            query: ({ importType }) => ({
                url: `netsuite/imports/?type=${importType}`,
                method: 'GET',
            }),
            providesTags: ['NetSuiteImports'],
        }),
        addNetSuiteImport: build.mutation({
            query: ({ importFile, importType }) => {
                const url = `netsuite/imports/type/${importType}`
                const body = new FormData()
                body.append('formFile', importFile)
                return { url, body, method: 'POST', formData: true }
            },
            invalidatesTags: ['NetSuiteImports'],
        }),
        searchMarketplaceCustomer: build.query({
            query: (customerId) => ({
                url: `netsuite/search-customer/${customerId}`,
                method: 'GET',
            }),
        }),
        syncShopifyCustomer: build.mutation({
            query: customer => ({
                url: `netsuite/customer/shopify/sync/`,
                method: 'POST',
                body: customer
            }),
        }),
        saveMarketplaceCustomer: build.mutation({
            query: customer => ({
                url: `netsuite/customer/save`,
                method: 'POST',
                body: customer
            }),
        }),
        migrateListingToPartner: build.mutation({
            query: partner => ({
                url: `partners/listings/migrate`,
                method: 'PUT',
                body: partner
            }),
        }),
        hasCodePoolOffers: build.query({
            query: (partnerListingId) => ({
                url: `offers/listing/${partnerListingId}/hascodepools`,
                method: 'GET',
            }),
        }),
        getAllPartners: build.query({
            query: () => '/partners/all',
            providesTags: ['AllPartners'],
        }),
        updatePartner: build.mutation({
            query: (updatePartner) => ({
                url: 'partners',
                method: 'PUT',
                body: updatePartner,
            }),
            invalidatesTags: ['AllPartners'],
        }),
        archivePartner: build.mutation({
            query: (id) => ({
                url: `partners/${id}/archive`,
                method: 'PUT',
            }),
            invalidatesTags: ['AllPartners'],
        }),
        createPartner: build.mutation({
            query: (newPartner) => ({
                url: 'partners',
                method: 'POST',
                body: newPartner,
            }),
            invalidatesTags: ['AllPartners'],
        }),
    })
})

const initialState = [];
const partnersSlice = createSlice({
    name: 'partners',
    initialState,
    reducers: {},
})

export const {
    useArchiveListingMutation,
    useFetchPartnerBySearchTermQuery,
    useFetchPartnerNetSuiteMarketplaceCustomerQuery,
    useLazyFetchPartnerNetSuiteMarketplaceCustomerQuery,
    useDeletePartnerCustomerMutation,
    useLazySearchMarketplaceCustomerQuery,
    useGetNetSuiteImportQuery,
    useGetNetSuiteImportsQuery,
    useLazyGetNetSuiteImportQuery,
    useLazyGetNetSuiteImportsQuery,
    useAddNetSuiteImportMutation,
    useMigrateListingToPartnerMutation,
    useSyncShopifyCustomerMutation,
    useSaveMarketplaceCustomerMutation,
    useLazyHasCodePoolOffersQuery,
    useGetAllPartnersQuery,
    useUpdatePartnerMutation,
    useArchivePartnerMutation,
    useCreatePartnerMutation,
} = partnersApiSlice

export default partnersSlice.reducer